// extracted by mini-css-extract-plugin
export default {"banner":"banners_banner__ELGeM","bannerVideo":"banners_bannerVideo__FuxWH"};